module.exports = __webpack_public_path__ + "static/media/notifications-not-found.0405d1f5.svg";